import { render, staticRenderFns } from "./address-item.vue?vue&type=template&id=29086d92&scoped=true&"
import script from "./address-item.vue?vue&type=script&lang=js&"
export * from "./address-item.vue?vue&type=script&lang=js&"
import style0 from "./address-item.vue?vue&type=style&index=0&id=29086d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29086d92",
  null
  
)

export default component.exports